import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoho = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 2500,
	height: 864,
	viewBox: "0 0 512 177",
	xmlns: "http://www.w3.org/2000/svg",
	preserveAspectRatio: "xMidYMid",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				x1: "49.996%",
				y1: "1.431%",
				x2: "49.996%",
				y2: "96.981%",
				id: "a",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#FFE513",
					offset: ".562%"
				}), /* @__PURE__ */ _jsx("stop", {
					stopColor: "#FDB924",
					offset: "100%"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				x1: "4.512%",
				y1: "13.494%",
				x2: "95.672%",
				y2: "87.064%",
				id: "b",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#008CD2",
					offset: ".562%"
				}), /* @__PURE__ */ _jsx("stop", {
					stopColor: "#00649D",
					offset: "100%"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				x1: "50.002%",
				y1: "27.779%",
				x2: "50.002%",
				y2: "97.529%",
				id: "c",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#26A146",
					offset: "0%"
				}), /* @__PURE__ */ _jsx("stop", {
					stopColor: "#008A52",
					offset: "100%"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				x1: "43.734%",
				y1: "8.208%",
				x2: "57.544%",
				y2: "93.198%",
				id: "d",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#D92231",
					offset: "0%"
				}), /* @__PURE__ */ _jsx("stop", {
					stopColor: "#BA2234",
					offset: "100%"
				})]
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			d: "M512 37.7v121.4l-16.8 16.4V56.7l16.8-19z",
			fill: "#E79225"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M401.9 37.8l-17.4 18.9.9 1.2 109.1-.4 1-.8 16.5-19-110.1.1z",
			fill: "#FFF16D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#a)",
			d: "M.5 19.7h111v118.9H.5z",
			transform: "translate(384 37)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M478.6 99.5c-2.2-5.5-5.5-10.5-9.8-14.8-4.1-4.2-8.7-7.4-13.9-9.5-5.1-2.1-10.6-3.2-16.6-3.2-6 0-11.6 1.1-16.7 3.2-5.2 2.1-9.8 5.3-13.9 9.5-4.3 4.3-7.5 9.3-9.7 14.8-2.2 5.5-3.2 11.5-3.2 18.1 0 6.4 1.1 12.4 3.3 18 2.2 5.6 5.4 10.6 9.7 15 4 4.1 8.6 7.2 13.7 9.3 5.1 2.1 10.8 3.2 16.9 3.2 5.9 0 11.4-1.1 16.5-3.2s9.8-5.2 13.9-9.3c4.3-4.4 7.6-9.4 9.8-14.9 2.2-5.5 3.3-11.6 3.3-18 0-6.7-1.1-12.7-3.3-18.2zm-22.9 39.2c-4.3 5.1-10 7.7-17.4 7.7-7.4 0-13.2-2.6-17.5-7.7-4.3-5.1-6.4-12.2-6.4-21.2 0-9.2 2.2-16.3 6.4-21.5 4.3-5.2 10-7.7 17.5-7.7 7.4 0 13.1 2.6 17.4 7.7 4.2 5.2 6.4 12.3 6.4 21.5 0 9-2.1 16.1-6.4 21.2z",
			fill: "#FFF"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M373.6 27.8v.6l14.2 109.1-8.3 23-1.1-.8-14.6-104.6.3-1.4 9.1-25.3.4-.6z",
				fill: "#009ADA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M264.3 43l109.3-15.2-9.2 26.2-1.3 1.4-102.2 15 .5-18.7 2.9-8.7z",
				fill: "#91C9ED"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M107.4 27l15.1 106.5-107.7 15.1L.3 45.7l6.3-4.9L107.4 27z",
				fill: "url(#b)",
				transform: "translate(257 27)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M346.1 74.4c-.5-3.3-1.6-5.8-3.4-7.5-1.5-1.3-3.3-2-5.4-2-.5 0-1.1 0-1.7.1-2.8.4-4.9 1.7-6.2 3.8-1 1.5-1.4 3.4-1.4 5.6 0 .8.1 1.7.2 2.6l3.9 27.7-31 4.6-3.9-27.7c-.5-3.2-1.6-5.7-3.4-7.4-1.5-1.4-3.3-2.1-5.3-2.1-.5 0-1 0-1.5.1-2.9.4-5.1 1.7-6.5 3.8-1 1.5-1.4 3.4-1.4 5.6 0 .8.1 1.7.2 2.7l10.6 72.1c.5 3.3 1.6 5.8 3.6 7.5 1.5 1.3 3.3 1.9 5.5 1.9.6 0 1.2 0 1.8-.1 2.7-.4 4.7-1.7 6-3.8.9-1.5 1.3-3.3 1.3-5.4 0-.8-.1-1.7-.2-2.6l-4.3-28.5 31-4.6 4.3 28.5c.5 3.3 1.6 5.8 3.5 7.4 1.5 1.3 3.3 2 5.4 2 .5 0 1.1 0 1.7-.1 2.8-.4 4.9-1.7 6.2-3.8.9-1.5 1.4-3.3 1.4-5.5 0-.8-.1-1.7-.2-2.6l-10.8-72.3z",
				fill: "#FFF"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M162 0l-38.9 92.4 5.3 40.6.3-.1 43.7-98.3-.2-2.1-9.4-31.2L162 0z",
				fill: "#66BF6B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162 0l10.1 33.9.2.7 96.2 43.1.3-.2-8.2-32.4L162 0z",
				fill: "#98D0A0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M49.1 33.9l96.7 43.6-43.7 99.1L5.4 133l43.7-99.1z",
				fill: "url(#c)",
				transform: "translate(123)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M239.5 85.5c-2.1-5.6-5-10.4-8.8-14.4-3.8-4-8.4-7.2-13.8-9.5s-10.8-3.4-16.3-3.4h-.3c-5.6 0-11.1 1.3-16.5 3.7-5.7 2.5-10.6 5.9-14.8 10.4-4.2 4.4-7.6 9.8-10.2 16-2.6 6.1-4 12.3-4.3 18.4v2.1c0 5.4.9 10.7 2.8 15.9 2 5.5 4.9 10.2 8.7 14.2 3.8 4 8.5 7.2 14.1 9.5 5.3 2.3 10.7 3.4 16.2 3.4h.1c5.5 0 11-1.2 16.4-3.5 5.7-2.5 10.7-6 14.9-10.5 4.2-4.4 7.7-9.7 10.3-15.9 2.6-6.2 4-12.3 4.3-18.4v-1.8c.1-5.5-.8-10.9-2.8-16.2zm-19.3 28.8c-3.6 8.6-8.5 14.5-14.4 17.7-3.2 1.7-6.5 2.6-9.8 2.6-2.9 0-6-.7-9.1-2-6.8-2.9-11-7.5-12.8-14.1-.6-2.2-.9-4.5-.9-6.9 0-4.8 1.2-10.1 3.6-15.8 3.7-8.8 8.6-14.8 14.5-18.1 3.2-1.8 6.5-2.6 9.8-2.6 3 0 6 .7 9.2 2 6.7 2.9 10.9 7.5 12.7 14.1.6 2.1.9 4.4.9 6.8 0 5-1.2 10.4-3.7 16.3z",
				fill: "#FFF"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M115.4 15.7l15.8 105.8-7.2 37.2-1-1.3-15.4-102.2v-2l6.8-35.7 1-1.8z",
				fill: "#760D16"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 70.4L7.5 33l107.9-17.3-7.3 38.1v2.5L1.3 71.4l-1.3-1z",
				fill: "#EF463E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M108.1 38.8L124 143.7 17.2 160.4 0 55.4l108.1-16.6z",
				fill: "url(#d)",
				transform: "translate(0 15)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M96.6 142c-.8-1-2-1.7-3.4-2.2-1.4-.5-3.1-.7-5.2-.7-1.9 0-4.1.2-6.5.6l-28.2 4.8c.3-2.2 1.4-5 3.3-8.5 2.1-3.9 5.3-8.6 9.4-14 1.4-1.9 2.5-3.3 3.3-4.3.5-.7 1.3-1.6 2.3-2.9 6.5-8.5 10.4-15.4 12-20.8.9-3.1 1.4-6.2 1.6-9.3.1-.9.1-1.7.1-2.5 0-2.2-.2-4.4-.6-6.6-.3-2-.8-3.6-1.5-4.9-.7-1.3-1.5-2.3-2.5-2.9-1.1-.7-2.8-1-4.9-1-1.7 0-3.8.2-6.3.6L36.9 73c-3.9.7-6.9 1.8-8.7 3.6-1.5 1.4-2.2 3.2-2.2 5.2 0 .5 0 1.1.1 1.7.5 2.8 1.9 4.8 4.2 5.8 1.4.6 3 .9 5 .9 1.3 0 2.8-.1 4.4-.4L66.9 85c0 .5.1 1 .1 1.4 0 1.7-.3 3.4-.9 5-.8 2.3-2.8 5.5-6.1 9.6-.9 1.1-2.3 2.9-4.2 5.2-7.4 8.9-12.6 16.5-15.8 22.8-2.3 4.4-3.8 8.6-4.7 12.9-.5 2.5-.8 4.8-.8 7.1 0 1.6.1 3.2.4 4.7.4 2.2.9 4 1.6 5.4.7 1.4 1.7 2.5 2.8 3.1 1.1.6 2.6.8 4.8.8 2.7 0 6.4-.4 11.1-1.2l29.6-5.1c5.2-.9 8.9-2.2 11-3.9 1.7-1.4 2.6-3.3 2.6-5.5 0-.6-.1-1.2-.2-1.8-.2-1.3-.7-2.5-1.6-3.5z",
				fill: "#FFF"
			})
		] })
	]
});
export default SvgZoho;
